/**
 * Report Service - 报表数据服务
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as reportMock from '../../mocks/report';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';

/**
 * 查询 SLA 履约报表
 */
export async function pageSLAFulfillment(params) {
  if (config.mock) {
    return reportMock.mockPageSLAFulfillment(params);
  }

  return httpClient.post(API_ENDPOINTS.REPORT.SLA_FULFILLMENT_PAGE, params);
}

/**
 * 导出 SLA 报表
 */
export async function exportSLAFulfillment(params) {
  return httpClient.post(API_ENDPOINTS.REPORT.SLA_FULFILLMENT_EXPORT, params);
}

/**
 * 查询 SLA 报表渠道选项
 */
export async function getSlaChannelOptions() {
  return httpClient.post(API_ENDPOINTS.REPORT.SLA_CHANNEL_OPTION, {});
}

/**
 * 查询 SLA 报表支付方式选项
 */
export async function getSlaPaymentMethodOptions() {
  return httpClient.post(API_ENDPOINTS.REPORT.SLA_PAYMENT_METHOD_OPTION, {});
}

/**
 * 查询支付发票报表
 */
export async function pagePaymentInvoice(params) {
  if (config.mock) {
    return reportMock.mockPagePaymentInvoice(params);
  }

  return httpClient.post(API_ENDPOINTS.REPORT.PAYMENT_INVOICE_PAGE, params);
}
